/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.1.4
 */
import Tool from './Tool'
//
let { Polyline } = L;
/**
 * 铅笔工具
 */
export default class PenTool extends Tool {
  marker
  options = { feature: { color: 'red' } }
  /**
   * 启动
   */
  start() {
    this.onMouseMove = this.onMouseMove.bind(this)
    this.onMouseDown = this.onMouseDown.bind(this)
    this.map.once('mousedown', this.onMouseDown);
    //
    this.restart = true;
  }
  /**
   * 取消
   */
  cancel() {
    this.map.off('mousedown', this.onMouseDown);
    this.map.off('mousemove', this.onMouseMove);
  }
  /**
   * 绘制-start
   * @param e 
   */
  onMouseDown(e) {
    this.reset();
    //
    let { marker, options, map, layer } = this;
    let { latlng } = e;
    //
    if (!marker) {
      marker = this.marker = new Polyline([latlng], options.feature).addTo(layer)
      map.once('mouseup', this.onEnd.bind(this));
      map.on('mousemove', this.onMouseMove);
    }
  }
  /**
   * 绘制ing
   * @param e 
   */
  onMouseMove(e) {
    this.marker.addLatLng(e.latlng)
  }
}


// WEBPACK FOOTER //
// ./src/plugins/tools/PenTool.js